import React, {Suspense, useEffect, useRef, useState} from 'react'
import Background from "../../components/backgroundImage";
import {MicrobeBackButton} from "../../components/microbeBackButton";
import {Images} from "../../AssetReferences";

import CybershoreGame from "./cybershore_game";
import CybershoreCover from "./cybershore_cover";
import TextMeditations from "./text_meditations";

import s from "./styles.module.css"
import {useNavigate} from "react-router-dom";
import {PageTitles, SitePages} from "../../SitePages";
import {useTitle} from "../../hooks/UseTitle";

class Screens {
    static Cover = 0;
    static Game = 1;
    
    static TextMeditation = 2;
}

export default function CybershoreMeditations({}) {       
    const [currentTextMeditation, setCurrentTextMeditation] = useState(0)    
    const [currentScreen, setCurrentScreen] = useState(0)
    
    const navigate = useNavigate();
    useTitle(PageTitles.CybershoreMeditations)
    
    function onExit()
    {
        navigate(`../${SitePages.Home}`);
    }

    
    function DisplayMeditationText(index){
        setCurrentTextMeditation(index);
        setCurrentScreen(Screens.TextMeditation);        
    }
    
    function DisplayScreen({index})
    {
        switch (index)
        {
            case Screens.Cover: return <CybershoreCover
                onStartGame={() => setCurrentScreen(Screens.Game)}
                onOpenMeditationText={DisplayMeditationText}
            />
            
            case Screens.Game: return <CybershoreGame 
                displayCover={false}
            />
            
            case Screens.TextMeditation: return <TextMeditations 
                index={currentTextMeditation}
                onExit={() => setCurrentScreen(Screens.Cover)}
            />
            
            default: console.error("DisplayScreen could not find a matching screen at displayIndex", index);
        }
    }

    return (
        <>
            {currentScreen === Screens.Cover ||  currentScreen === Screens.Game               
                ?            
                <div style={{opacity: currentScreen === Screens.Cover ? "67%" : "33%"}} className={s.background}>
                    <Background
                        src={Images.CybershoreBackground}
                        opacity="100%"
                        background_color={"white"}/>

                </div>
            : null }
            
            

            <MicrobeBackButton
                image_src={Images.ToiSmall}
                size={5}
                tooltip={"Click to return to homepage"}
                onClick={onExit}
                left={1}
                top={2}
            />

            <DisplayScreen
                index={currentScreen}
            />
            
        </>
    )
}
